/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { delayedResponse } from '../companies/companiesMock';
import { makeMockResponse } from '../mockUtils';
import { Cashback, VatVerificationInfo } from './cashbackClient.typings';
import { cashbackFactory, edvgerialInfoFactory, taxFreeInfoInfoFactory } from './cashbackFactories';

const CASHBACK_URL = /\/cashback\/(\w+)$/;
const CASHBACK_VERIFY_URL = /\/cashback\/(\w+)\/verify/;

export function addCashbackMockApi(mockAdapter: MockAdapter): void {
    mockAdapter.onGet(CASHBACK_URL).reply((config) => {
        const data: Cashback = cashbackFactory.item();

        return delayedResponse(makeMockResponse(200, data, config), 3000);
    });

    mockAdapter.onGet(CASHBACK_VERIFY_URL).reply((config) => {
        const data: VatVerificationInfo = {
            edvgerial: edvgerialInfoFactory.list({ count: 1 }),
            taxFree: taxFreeInfoInfoFactory.list({ count: 4 }),
        };

        return delayedResponse(makeMockResponse(200, data, config), 3000);
    });
}
